/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Timer(props) {
    return (
        <SvgIcon {...props}>
            <symbol id="a" viewBox="-10 -10 20 20">
                <path d="M0-10c-5.514,0-10,4.486-10,10s4.486,10,10,10S10,5.514,10,0S5.514-10,0-10z M0,7.932 c-4.373,0-7.932-3.559-7.932-7.932S-4.373-7.932,0-7.932S7.932-4.373,7.932,0S4.373,7.932,0,7.932z M4.883,2.227L3.484,3.752 l-3.616-3.319l-2.427,1.106l-0.859-1.882L0.257-2.02L4.883,2.227z" />
            </symbol>
            <use xlinkHref="#a" width="20" height="20" x="-10" y="-10" transform="matrix(0.65 0 0 -0.65 6.5 7.0005)" overflow="visible" />
        </SvgIcon>
    );
}

Timer.defaultProps = {
    viewBox: '0 0 13 16'
};

export default Timer;
